import React, { Component } from "react";

const credits = [
  {
    organization: "",
    whos: [
      {
        name: "Investigación / Textos",
        whos: [
          { name: "Erendira Aquino", url: "https://twitter.com/ere_aquino" },
          {
            name: "Gonzalo Ortuño",
            url: "https://twitter.com/periodistagonzo"
          },
          { name: "León Ramírez", url: "https://twitter.com/leonramz" },
          { name: "César Reveles", url: "https://twitter.com/RevelesCsar" }
        ]
      },
      {
        name: "Redes sociales",
        whos: [
          { name: "Gerardo Borbolla", url: "https://twitter.com/gerardo_ebg" },
          {
            name: "Fernando Montes de Oca",
            url: "https://twitter.com/NandodeOca"
          }
        ]
      },
      {
        name: "Edición y coordinación general",
        whos: [{ name: "Lizbeth Padilla", url: "https://twitter.com/liz_pf" }]
      }
    ]
  },
  {
    organization: "",
    before: (
      <div className="before-credits">
        <div style={{ height: "9px" }} />
        <a href="https://www.fuistetu.org/" target="_blank">
          fuistetu.org
        </a>
        <br />
        <a href="https://twitter.com/fuistetu_mx" target="_blank">
          @fuistetu_mx
        </a>
      </div>
    ),
    whos: [
      { name: "Oxfam", url: "https://www.oxfammexico.org/" },
      { name: "Borde Político", url: "http://bordepolitico.com/" },
      { name: "Data Cívica", url: "https://datacivica.org/" },
      { name: "Horizontal", url: "https://horizontal.mx/" },
      { name: "Transparencia Internacional", url: "https://www.tm.org.mx/" },
      { name: "Incorruptible", url: "https://incorruptible.mx/" },
      { name: "Causa en Común", url: "http://causaencomun.org.mx/" },
      { name: "Integralia", url: "http://integralia.com.mx/" }
    ]
  }
];

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="credits">
          <div className="credits-title">Créditos</div>
          <div className="credits-cols">
            {credits.map(function(org) {
              // IS SIMPLE?
              var ws = org.whos;
              var issimple = ws[0].url;
              var arr = [];
              for (var i = 0; i < ws.length; i++) {
                var em = ws[i];

                if (issimple) {
                  if (i === 0) {
                    arr.push(
                      <strong style={{ marginTop: "10px", display: "block" }}>
                        Miembros
                      </strong>
                    );
                  }
                  var ins = (
                    <div className="col-credit-tr simple">
                      <div className="name">
                        <a href={em.url} target="_blank">
                          {em.name}
                        </a>
                      </div>
                    </div>
                  );
                } else {
                  var ss = [];
                  for (var z = 0; z < em.whos.length; z++) {
                    ss.push(
                      <div className="credit-group-sub">
                        <a href={em.whos[z].url} target="_blank">
                          {em.whos[z].name}
                        </a>
                      </div>
                    );
                  }
                  var ins = (
                    <div className="col-credit-tr">
                      <div className="credit-group-title">{em.name}</div>
                      <div className="credit-group">{ss}</div>
                    </div>
                  );
                }
                arr.push(ins);
              }
              return (
                <div className="credits-col">
                  <div className="credits-col-title">
                    <img src={org.organization} />
                  </div>
                  {org.before}
                  <div className="credits-col-info">{arr}</div>
                </div>
              );
            })}
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.js